var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import Loading from "@irati/ui/src/Loading";
import { injectIntl, FormattedMessage } from "@irati/utils/lang";
import History from "@irati/utils/history";
import getMessage from "@irati/utils/lang/helpers/getMessage";
import { H1, H2 } from "@irati/ui/src/Typography";
import { PaymentState } from "@irati/payments/enums";
import tracking from "@irati-tracking/perks/perks";
import { getAdyenClassicCallbackUrlForRedirect, getZipCallbackUrlForRedirect } from "@irati/deals/utils/redemption/payments";
import PaymentForm from "@irati-web/payments/src/components/PaymentForm";
import { PaymentProvider } from "@irati/types";
import basket from "@irati/checkout/utils/basket";
import authentication from "@irati/auth";
import PerksPaymentSelect from "@irati-web/payments/src/components/PerksPaymentSelect";
import PaymentFormZip from "@irati-web/payments/src/components/PaymentFormZip";
import redemptionUtils from "../../helpers/redemption/redemptionUtils";
import DealSEO from "../../components/DealSEO";
import ProductLayout from "../../components/ProductForms/ProductLayout";
import ErrorNotification from "../../components/ErrorNotification";
import OnLeaveRedemption from "../OnLeaveRedemption/OnLeaveRedemption";
import SagaStep from "../../components/ProductForms/SagaStep";
import SagaSteps from "../../constants/sagaSteps";
import TermsAndConditions from "../../components/ProductForms/TermsAndConditions";
var COMPLETE = "COMPLETE";
var CREDIT_CARD_PAYMENT_METHOD = "CREDIT_CARD";
var WALLET_PAYMENT_METHOD = "WALLET";
var PaymentOrder = /** @class */ (function (_super) {
    __extends(PaymentOrder, _super);
    function PaymentOrder(props) {
        var _this = _super.call(this, props) || this;
        _this.handleCorrectStep = function () {
            var saga = get(_this.props, "match.params.sagaUuid", null);
            var load = redemptionUtils
                .handleIncorrectStep(saga)
                .then(function (latestSaga) {
                _this.setState({
                    saga: latestSaga,
                    deal: latestSaga.deal
                });
                if (latestSaga.status === COMPLETE) {
                    _this.setState({ block: false }, function () {
                        History.replace({
                            pathname: "/info/" + latestSaga.deal.urlSlug + "/success/" + latestSaga.uuid
                        }, _this.context);
                    });
                }
                else if (latestSaga.nextStep !== SagaSteps.PAY || basket.items.length === 0) {
                    // Next step is not pay, redemption not completed & empty basket
                    throw new Error(_this.props.formatMessage({ id: "perks.containers.paymentOrder.error.unableToContinue" }));
                }
                // All is well. Let's pay.
            })
                .catch(function (err) { return _this.setState({ error: redemptionUtils.handleSagaErrors(err), block: false, submit: null }); });
            _this.setState({ load: load });
        };
        _this.paymentComplete = function () {
            var _a = _this.state, deal = _a.deal, saga = _a.saga;
            var load = redemptionUtils
                .complete(saga)
                .then(function (updatedSaga) {
                _this.setState({ block: false });
                var nextStep = redemptionUtils.currentStep(updatedSaga, deal);
                History.replace({
                    pathname: nextStep,
                    state: {
                        deal: deal,
                        saga: updatedSaga
                    }
                }, _this.context);
            })
                .catch(function () {
                // @TODO: Change this to handle errors in line
                // ^^ Cannot do this yet as saga service will unreserve stock on failure.
                _this.setState({ block: false }, function () {
                    History.replace({
                        pathname: "/info/" + deal.urlSlug + "/pay/" + saga.uuid + "/error",
                        state: { deal: deal }
                    }, _this.context);
                });
            });
            _this.setState({ load: load });
            var walletAmount = _this.getAmountForProvider(PaymentProvider.Wallet);
            tracking.redeemPerkCompleteCheckout(deal, basket.breakdown.total.amount, basket.breakdown.total.currency, walletAmount);
        };
        _this.handleContinue = function () {
            _this.setState({
                continuePressed: true
            });
            var user = authentication.user();
            var userId = user.uuid;
            var _a = _this.state, saga = _a.saga, deal = _a.deal;
            tracking.redeemPerkSagaStatus(deal, saga);
            var details = {
                userId: userId
            };
            var load = redemptionUtils.nextStep(saga, deal, details).then(function (updatedSaga) {
                var paymentOrder = updatedSaga.paymentOrder;
                _this.setState({
                    saga: updatedSaga,
                    paymentOrder: paymentOrder
                });
                var adyenClassicAmount = _this.getAmountForProvider(PaymentProvider.AdyenClassic);
                var zipAmount = _this.getAmountForProvider(PaymentProvider.Zip);
                if (!adyenClassicAmount && !zipAmount) {
                    tracking.paymentMethodSelected(WALLET_PAYMENT_METHOD);
                    _this.paymentComplete();
                }
            });
            _this.setState({ load: load });
        };
        _this.handleTermsAndConditions = function (termsAgreed) { return _this.setState({ termsAgreed: termsAgreed }); };
        _this.handleFormComplete = function (data) {
            if (data && data.type === PaymentState.PAYMENT_COMPLETE) {
                tracking.paymentMethodSelected(CREDIT_CARD_PAYMENT_METHOD);
                _this.paymentComplete();
            }
        };
        _this.getAmountForProvider = function (type) {
            var _a;
            return ((_a = _this.state.paymentBreakdown.find(function (t) { return t.type === type; })) === null || _a === void 0 ? void 0 : _a.amount) || 0;
        };
        _this.handlePaymentChange = function (paymentBreakdown) {
            _this.setState({ paymentBreakdown: paymentBreakdown });
        };
        _this.state = {
            deal: get(props, "location.state.deal", {}),
            saga: get(props, "location.state.saga", null),
            error: null,
            block: true,
            continuePressed: false,
            paymentOrder: null,
            termsAgreed: false,
            paymentBreakdown: []
        };
        return _this;
    }
    PaymentOrder.prototype.componentDidMount = function () {
        this.handleCorrectStep();
    };
    PaymentOrder.prototype.render = function () {
        var _this = this;
        var _a = this.state, deal = _a.deal, error = _a.error, saga = _a.saga, load = _a.load, block = _a.block, continuePressed = _a.continuePressed, termsAgreed = _a.termsAgreed, paymentOrder = _a.paymentOrder, paymentBreakdown = _a.paymentBreakdown;
        var formatMessage = this.props.formatMessage;
        var adyenClassicAmount = this.getAmountForProvider(PaymentProvider.AdyenClassic);
        var zipAmount = this.getAmountForProvider(PaymentProvider.Zip);
        var walletAmount = this.getAmountForProvider(PaymentProvider.Wallet);
        var canContinue = paymentBreakdown.length > 0 && termsAgreed;
        return (React.createElement(Loading, { load: load },
            React.createElement(DealSEO, { deal: deal, pageTitle: formatMessage({ id: "perks.containers.paymentOrder.dealSEO.pagetitle" }) }),
            React.createElement(OnLeaveRedemption, { block: block }),
            React.createElement(ProductLayout, { onClick: this.handleContinue, deal: deal, email: get(this.state, "saga.redemption.email", null), disabled: !canContinue, continueHidden: continuePressed, walletBalanceToUse: walletAmount, buttonText: walletAmount > 0 && formatMessage({ id: "perks.containers.paymentOrder.paymentOption.buttonText" }) },
                error && React.createElement(ErrorNotification, null, getMessage(formatMessage, error)),
                !error && (React.createElement(React.Fragment, null,
                    !continuePressed && (React.createElement(React.Fragment, null,
                        React.createElement(SagaStep, null),
                        React.createElement(H1, null,
                            React.createElement(FormattedMessage, { id: "perks.containers.paymentOrder.paymentOption.title" })),
                        React.createElement(PerksPaymentSelect, { deal: deal, onChange: this.handlePaymentChange }),
                        React.createElement(TermsAndConditions, { onChange: function () { return _this.handleTermsAndConditions(!termsAgreed); }, termsAgreed: termsAgreed }))),
                    continuePressed && paymentOrder && !!adyenClassicAmount &&
                        React.createElement(React.Fragment, null,
                            React.createElement(SagaStep, { saga: saga }),
                            React.createElement(H2, null,
                                React.createElement(FormattedMessage, { id: "perks.containers.paymentOrder.paymentOption.checkout" })),
                            React.createElement(PaymentForm, { paymentOrder: paymentOrder, amount: adyenClassicAmount, onComplete: this.handleFormComplete, redirectReturnUrl: getAdyenClassicCallbackUrlForRedirect(deal, saga) })),
                    continuePressed && paymentOrder && !!zipAmount &&
                        React.createElement(PaymentFormZip, { paymentOrder: paymentOrder, redirectReturnUrl: getZipCallbackUrlForRedirect(deal, saga) }))))));
    };
    PaymentOrder.contextTypes = {
        // required for history redirect
        appPath: PropTypes.string.isRequired
    };
    return PaymentOrder;
}(Component));
export default injectIntl(PaymentOrder);
